import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.help.sms-settings', {
        url: '/sms-settings',
        component: 'companySmsServicesHelpSmsSettings',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/sms-settings/sms-settings.state.js